export default "__VITE_ASSET__b14d9cbf__"